import { createRouter, createWebHistory } from "vue-router";
import { checkForAuthorization } from "@/App/router/checkForAuthorization";
import { routes } from "@/App/router/routes";
import { checkForOngoingLiveConsult } from "@/App/router/checkForOngoingLiveConsult";
import { checkRole } from "@/App/router/checkRole";
import { CaseType, type TwiageCase } from "@/App/types/twiageTypes";
import { RoutePath } from "@/App/router/routePath";
import { setMapviewAsDefaultForMih } from "@/App/router/setMapviewAsDefaultForMih";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(checkForAuthorization);
router.beforeEach(checkRole);
router.beforeEach(checkForOngoingLiveConsult);
router.beforeEach(setMapviewAsDefaultForMih);

export default router;

const CaseTypeToPath: Record<CaseType, RoutePath> = {
  [CaseType.mih]: RoutePath.mih,
  [CaseType.ift]: RoutePath.ift,
  [CaseType.ems]: RoutePath.cases,
  [CaseType.hospital]: RoutePath.cases,
};

export const twiageRouter = {
  caseListPath: ({ twiageCase }: { twiageCase: TwiageCase | null } = { twiageCase: null }): string => {
    return twiageCase?.type ? CaseTypeToPath[twiageCase?.type] : RoutePath.cases;
  },
  caseDetails({ twiageCase }: { twiageCase: TwiageCase }): Promise<unknown> {
    return router.push(`${this.caseListPath({ twiageCase })}/${twiageCase.id}`);
  },
};
